import {
  TaskDomainSchema,
  TaskSubtypeSchema,
} from "@redotech/redo-model/task/task";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const subtypeCountSchema_ = z.object({
  subtype: TaskSubtypeSchema,
  count: z.number().int().nonnegative(),
});
export const subtypeCountSchema: z.ZodType<SubtypeCount> = subtypeCountSchema_;
export interface SubtypeCount extends z.infer<typeof subtypeCountSchema_> {}

export const getTasksMetrics = unaryRpc({
  name: "getTasksMetrics" as const,
  input: z.object({
    domain: TaskDomainSchema.optional(),
    /** Window in days for the "completed" card. Defaults to 7. */
    completedWindowDays: z.number().int().positive().max(90).optional(),
  }),
  output: z.object({
    pendingTotal: z.number().int().nonnegative(),
    pendingHighPriority: z.number().int().nonnegative(),
    pendingBySubtype: z.array(subtypeCountSchema),
    completedInWindow: z.number().int().nonnegative(),
    /** Average resolve time across completed tasks in the window, in seconds. Null if no completed tasks. */
    avgResolveSeconds: z.number().nonnegative().nullable(),
  }),
});
